import { 
  FETCH_FILTER_CATEGORY_SET_SUCCESS,
  FETCH_FILTER_CATEGORY_SET_PENDING,
  FETCH_FILTER_CATEGORY_SET_ERROR
} from '../constants/Constants';

const initialState = {
  pending: false,
  data:    [],
  error:   '',
}

export const requestFilterCategoryReducer = (state = initialState, action) => {
  
  switch (action.type) {
      case FETCH_FILTER_CATEGORY_SET_PENDING: return { ...state, pending: true, }
      case FETCH_FILTER_CATEGORY_SET_SUCCESS: return { ...state, pending: false, data: action.payload, }
      case FETCH_FILTER_CATEGORY_SET_ERROR:   return { ...state, pending: false, error: action.payload, }
      default: return state;
  }
}
